import React from 'react';

export const IconInsightsGrowth = () => (
  <svg
    width='369'
    height='209'
    viewBox='0 0 369 209'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_24576_4547)'>
      <path
        d='M19 181.208C19 151.866 26.6753 123.035 41.2637 97.5765C55.8521 72.1184 76.8462 50.9192 102.161 36.0839L136.18 94.1334C120.991 103.035 108.394 115.754 99.6413 131.029C90.8883 146.304 86.2831 163.603 86.2831 181.208H19Z'
        fill='#CF131D'
        stroke='#F6F6F6'
        strokeWidth='2.40297'
      />
      <path
        d='M102.723 35.7561C128.959 20.5172 158.828 12.6582 189.166 13.0114C219.505 13.3647 249.182 21.9171 275.056 37.7627L239.917 95.1407C224.393 85.6333 206.586 80.5019 188.383 80.2899C170.18 80.078 152.258 84.7934 136.517 93.9368L102.723 35.7561Z'
        fill='#FCA600'
        stroke='#F6F6F6'
        strokeWidth='2.40297'
      />
      <path
        d='M276.107 38.4116C300.277 53.4587 320.232 74.3945 334.103 99.2579C347.973 124.121 355.306 152.099 355.414 180.569L288.132 180.825C288.067 163.742 283.667 146.956 275.345 132.038C267.022 117.12 255.049 104.558 240.547 95.5301L276.107 38.4116Z'
        fill='#17C981'
        stroke='#F6F6F6'
        strokeWidth='2.40297'
      />
      <path
        d='M76.4799 119.703C76.4799 118.277 76.4799 116.842 76.4799 115.417C76.4799 114.825 76.6641 114.641 77.2459 114.641H83.3841C83.9077 114.641 84.1211 114.854 84.1211 115.378V122.505C84.1211 122.748 84.1599 122.845 84.4314 122.835C84.9259 122.806 85.692 122.825 86.1865 122.825C86.3417 122.825 86.4774 122.845 86.5453 123C86.6132 123.155 86.555 123.271 86.458 123.388C85.1295 124.949 81.9586 128.275 80.6302 129.836C80.4265 130.079 80.2714 130.079 80.058 129.827C78.7392 128.275 75.6556 124.959 74.3368 123.407C74.2302 123.281 74.1526 123.155 74.2399 122.99C74.3271 122.825 74.4532 122.825 74.6083 122.825C75.1029 122.825 75.6847 122.806 76.1792 122.835C76.4508 122.845 76.4992 122.748 76.4992 122.505C76.4799 121.041 76.4799 121.167 76.4799 119.703Z'
        fill='white'
      />
      <path
        d='M70.1285 121.313C69.9927 121.225 69.9248 121.06 69.9442 120.905C69.9539 120.469 69.9442 120.042 69.9539 119.606C69.9539 119.49 69.9151 119.451 69.8085 119.441C68.8969 119.305 68.0339 118.947 67.2969 118.403C67.0836 118.258 66.8897 118.093 66.7151 117.909C66.5794 117.754 66.56 117.628 66.686 117.463C66.9672 117.085 67.2485 116.716 67.5394 116.348C67.6945 116.154 67.8497 116.134 68.0436 116.299C68.6448 116.842 69.3721 117.22 70.1576 117.395C70.8169 117.531 71.4472 117.492 72.0485 117.133C72.6788 116.755 72.9891 115.756 72.1648 115.116C71.7382 114.787 71.2339 114.593 70.7297 114.379C70.0994 114.117 69.4594 113.885 68.8582 113.565C68.2569 113.245 67.7236 112.857 67.326 112.294C66.9091 111.703 66.7345 110.985 66.8218 110.268C66.9769 108.871 67.8206 108.018 69.0424 107.475C69.2945 107.368 69.5563 107.291 69.8279 107.242C69.9345 107.223 69.9442 107.174 69.9442 107.087C69.9442 106.622 69.9442 106.147 69.9442 105.681C69.9442 105.429 70.0509 105.322 70.303 105.322H71.3891C71.6121 105.322 71.7091 105.419 71.7091 105.642V107.048C71.7091 107.145 71.7382 107.184 71.8351 107.194C72.7563 107.3 73.6291 107.669 74.3563 108.241C74.3951 108.27 74.4339 108.309 74.4727 108.348C74.6376 108.503 74.6569 108.59 74.5406 108.784C74.3176 109.191 74.0945 109.589 73.8715 109.996C73.7454 110.219 73.5709 110.258 73.3576 110.093C73.0763 109.87 72.7757 109.676 72.446 109.521C71.7382 109.191 71.0109 109.046 70.2448 109.25C69.7309 109.385 69.2848 109.628 69.1103 110.18C68.9648 110.636 69.1103 111.073 69.4691 111.383C69.9345 111.8 70.5066 112.013 71.0788 112.236C71.7673 112.508 72.4557 112.77 73.1151 113.119C73.5806 113.361 73.9879 113.691 74.3176 114.088C74.6763 114.525 74.8412 115.048 74.8897 115.611C74.8897 115.669 74.8994 115.737 74.8994 115.795C74.9285 115.853 74.8897 115.931 74.9285 115.989V116.086C74.8897 116.309 74.9091 116.542 74.8509 116.765C74.7054 117.327 74.4339 117.841 74.0363 118.277C73.4642 118.917 72.7369 119.286 71.9127 119.47C71.8157 119.47 71.7479 119.557 71.7479 119.654V119.674C71.7576 120.1 71.7479 120.537 71.7479 120.973C71.7479 121.138 71.6897 121.264 71.5151 121.313H70.1285Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M80.6308 113.4C80.6308 107.911 76.1807 103.461 70.6914 103.461C65.202 103.461 60.752 107.911 60.752 113.4C60.752 118.889 65.202 123.339 70.6914 123.339L70.6914 126.636C63.3811 126.636 57.455 120.71 57.455 113.4C57.455 106.09 63.3811 100.164 70.6914 100.164C78.0016 100.164 83.9277 106.09 83.9277 113.4L80.6308 113.4Z'
        fill='white'
      />
      <g clipPath='url(#clip1_24576_4547)'>
        <path
          d='M186.313 55.8615C186.147 55.7548 186.064 55.5534 186.088 55.3639C186.1 54.8307 186.088 54.3095 186.1 53.7763C186.1 53.6342 186.052 53.5868 185.922 53.5749C184.808 53.4091 183.754 52.9707 182.853 52.3073C182.593 52.1296 182.356 51.9281 182.143 51.703C181.977 51.5135 181.953 51.3595 182.107 51.1581C182.451 50.696 182.794 50.2458 183.15 49.7956C183.339 49.5587 183.529 49.535 183.766 49.7364C184.5 50.3998 185.389 50.8619 186.348 51.0751C187.154 51.241 187.924 51.1936 188.659 50.7553C189.429 50.2932 189.808 49.0729 188.801 48.291C188.28 47.8882 187.664 47.6513 187.047 47.3906C186.277 47.0707 185.495 46.7864 184.761 46.3954C184.026 46.0045 183.375 45.5306 182.889 44.8434C182.38 44.1207 182.166 43.244 182.273 42.3673C182.463 40.6613 183.493 39.6188 184.986 38.9553C185.294 38.825 185.614 38.7302 185.946 38.671C186.076 38.6473 186.088 38.588 186.088 38.4814C186.088 37.9127 186.088 37.3322 186.088 36.7635C186.088 36.4555 186.218 36.3252 186.526 36.3252H187.853C188.126 36.3252 188.244 36.4437 188.244 36.7162V38.434C188.244 38.5525 188.28 38.5999 188.398 38.6117C189.524 38.7421 190.59 39.1923 191.478 39.8912C191.526 39.9268 191.573 39.9742 191.621 40.0216C191.822 40.2111 191.846 40.3178 191.703 40.5547C191.431 41.0523 191.158 41.538 190.886 42.0356C190.732 42.3081 190.519 42.3555 190.258 42.1541C189.915 41.8816 189.547 41.6447 189.144 41.4551C188.28 41.0523 187.391 40.8746 186.455 41.1234C185.827 41.2892 185.282 41.5854 185.069 42.2607C184.891 42.8175 185.069 43.3507 185.507 43.7298C186.076 44.2392 186.775 44.4999 187.474 44.7724C188.315 45.1041 189.156 45.424 189.962 45.8505C190.531 46.1466 191.028 46.5495 191.431 47.0352C191.869 47.5683 192.071 48.2081 192.13 48.8952C192.13 48.9663 192.142 49.0492 192.142 49.1203C192.177 49.1914 192.13 49.2862 192.177 49.3573V49.4757C192.13 49.7482 192.154 50.0326 192.083 50.3051C191.905 50.9922 191.573 51.6201 191.087 52.1532C190.388 52.9352 189.5 53.3854 188.493 53.6105C188.374 53.6105 188.291 53.7171 188.291 53.8356V53.8593C188.303 54.3805 188.291 54.9137 188.291 55.4468C188.291 55.6482 188.22 55.8022 188.007 55.8615H186.313Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M187 33.6847C180.092 33.6847 174.491 39.2852 174.491 46.1938C174.491 53.1023 180.092 58.7028 187 58.7028C193.909 58.7028 199.509 53.1023 199.509 46.1938C199.509 39.2852 193.909 33.6847 187 33.6847ZM171.194 46.1938C171.194 37.4643 178.271 30.3877 187 30.3877C195.73 30.3877 202.806 37.4643 202.806 46.1938C202.806 54.9232 195.73 61.9998 187 61.9998C178.271 61.9998 171.194 54.9232 171.194 46.1938Z'
          fill='white'
        />
      </g>
      <path
        d='M317.297 109.44C317.297 110.866 317.297 112.301 317.297 113.726C317.297 114.318 317.113 114.502 316.531 114.502L310.393 114.502C309.87 114.502 309.656 114.289 309.656 113.765L309.656 106.638C309.656 106.395 309.617 106.298 309.346 106.308C308.851 106.337 308.085 106.318 307.591 106.318C307.436 106.318 307.3 106.298 307.232 106.143C307.164 105.988 307.222 105.872 307.319 105.755C308.648 104.194 311.819 100.868 313.147 99.3068C313.351 99.0644 313.506 99.0644 313.719 99.3165C315.038 100.868 318.122 104.184 319.441 105.736C319.547 105.862 319.625 105.988 319.537 106.153C319.45 106.318 319.324 106.318 319.169 106.318C318.674 106.318 318.093 106.337 317.598 106.308C317.327 106.298 317.278 106.395 317.278 106.638C317.297 108.102 317.297 107.976 317.297 109.44Z'
        fill='white'
      />
      <path
        d='M303.128 125.482C302.993 125.395 302.925 125.23 302.944 125.075C302.954 124.638 302.944 124.212 302.954 123.775C302.954 123.659 302.915 123.62 302.808 123.61C301.897 123.475 301.034 123.116 300.297 122.573C300.084 122.427 299.89 122.263 299.715 122.078C299.579 121.923 299.56 121.797 299.686 121.632C299.967 121.254 300.248 120.886 300.539 120.517C300.695 120.323 300.85 120.304 301.044 120.469C301.645 121.012 302.372 121.39 303.158 121.564C303.817 121.7 304.447 121.661 305.048 121.303C305.679 120.924 305.989 119.926 305.165 119.286C304.738 118.956 304.234 118.762 303.73 118.549C303.099 118.287 302.459 118.054 301.858 117.734C301.257 117.414 300.724 117.026 300.326 116.464C299.909 115.872 299.735 115.155 299.822 114.437C299.977 113.041 300.821 112.187 302.042 111.644C302.295 111.538 302.556 111.46 302.828 111.412C302.935 111.392 302.944 111.344 302.944 111.257C302.944 110.791 302.944 110.316 302.944 109.85C302.944 109.598 303.051 109.492 303.303 109.492H304.389C304.612 109.492 304.709 109.589 304.709 109.812V111.218C304.709 111.315 304.738 111.354 304.835 111.363C305.756 111.47 306.629 111.838 307.356 112.41C307.395 112.44 307.434 112.478 307.473 112.517C307.638 112.672 307.657 112.76 307.541 112.954C307.318 113.361 307.095 113.758 306.871 114.166C306.745 114.389 306.571 114.427 306.358 114.263C306.076 114.04 305.776 113.846 305.446 113.69C304.738 113.361 304.011 113.215 303.245 113.419C302.731 113.555 302.285 113.797 302.11 114.35C301.965 114.806 302.11 115.242 302.469 115.552C302.935 115.969 303.507 116.183 304.079 116.406C304.767 116.677 305.456 116.939 306.115 117.288C306.581 117.53 306.988 117.86 307.318 118.258C307.676 118.694 307.841 119.218 307.89 119.78C307.89 119.838 307.899 119.906 307.899 119.964C307.928 120.023 307.89 120.1 307.928 120.158V120.255C307.89 120.478 307.909 120.711 307.851 120.934C307.705 121.497 307.434 122.01 307.036 122.447C306.464 123.087 305.737 123.455 304.913 123.64C304.816 123.64 304.748 123.727 304.748 123.824V123.843C304.758 124.27 304.748 124.706 304.748 125.143C304.748 125.307 304.69 125.434 304.515 125.482H303.128Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M303.69 107.63C298.201 107.63 293.751 112.08 293.751 117.569C293.751 123.059 298.201 127.509 303.69 127.509C309.18 127.509 313.63 123.059 313.63 117.569H316.927C316.927 124.88 311.001 130.806 303.69 130.806C296.38 130.806 290.454 124.88 290.454 117.569C290.454 110.259 296.38 104.333 303.69 104.333V107.63Z'
        fill='white'
      />
    </g>
    <g className='activeElement' filter='url(#filter0_d_24576_4547)'>
      <path
        d='M187.433 164.063L57.1844 180.276L187.799 193.217C188.084 193.254 188.371 193.282 188.661 193.303L189.109 193.347L189.109 193.328C189.365 193.338 189.624 193.341 189.884 193.338C198.016 193.236 204.525 186.561 204.423 178.429C204.321 170.297 197.646 163.788 189.514 163.89C189.255 163.893 188.996 163.902 188.74 163.919L188.74 163.9L188.293 163.955C188.004 163.983 187.717 164.018 187.433 164.063Z'
        fill='#F6F6F6'
      />
      <path
        d='M187.703 166.362L77.3337 180.024L188.011 190.912C188.253 190.944 188.496 190.968 188.742 190.985L189.121 191.022L189.121 191.006C189.339 191.014 189.558 191.017 189.778 191.014C196.669 190.928 202.185 185.307 202.099 178.458C202.013 171.61 196.358 166.129 189.467 166.216C189.247 166.219 189.028 166.226 188.811 166.241L188.81 166.224L188.432 166.271C188.187 166.294 187.944 166.324 187.703 166.362Z'
        fill='#343434'
      />
      <circle
        cx='189.7'
        cy='178.615'
        r='6.97501'
        transform='rotate(-90.7187 189.7 178.615)'
        fill='#F6F6F6'
      />
    </g>
    <g className='activeElement' filter='url(#filter1_d_24576_4547)'>
      <path
        d='M31.5535 182.117C32.2487 181.712 32.2455 180.707 31.5477 180.307L9.56753 167.71C8.86974 167.31 8.0007 167.815 8.00325 168.62L8.0836 193.954C8.08615 194.758 8.95838 195.258 9.65361 194.853L31.5535 182.117Z'
        fill='#343434'
      />
      <path
        d='M32.1452 179.265L10.165 166.667C8.66473 165.807 6.79629 166.894 6.80177 168.623L6.88212 193.957C6.8876 195.687 8.7629 196.761 10.2576 195.892L32.1575 183.155C33.6523 182.286 33.6454 180.125 32.1452 179.265Z'
        stroke='#F6F6F6'
        strokeWidth='2.40297'
      />
    </g>
    <defs>
      <filter
        id='filter0_d_24576_4547'
        x='47.1846'
        y='158.889'
        width='167.239'
        height='49.4587'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='5' />
        <feGaussianBlur stdDeviation='5' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_24576_4547'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_24576_4547'
          result='shape'
        />
      </filter>
      <filter
        id='filter1_d_24576_4547'
        x='0.79465'
        y='160.357'
        width='38.4869'
        height='41.8519'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feMorphology
          radius='4.80594'
          operator='erode'
          in='SourceAlpha'
          result='effect1_dropShadow_24576_4547'
        />
        <feOffset />
        <feGaussianBlur stdDeviation='4.80594' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_24576_4547'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_24576_4547'
          result='shape'
        />
      </filter>
      <clipPath id='clip0_24576_4547'>
        <rect width='363' height='197' fill='white' transform='translate(6)' />
      </clipPath>
      <clipPath id='clip1_24576_4547'>
        <rect
          width='32'
          height='32'
          fill='white'
          transform='translate(171 30)'
        />
      </clipPath>
    </defs>
  </svg>
);

export default IconInsightsGrowth;
